//GeneratorFlag:[NoChange]
import Feature from './feature';

export default {Feature}
export{Feature}